import React from "react";
import { Link } from "react-router-dom";
import { Target, CheckCircle, TrendingUp, Search, Share2 } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const MarketingDigital = () => {
  return (
    <div className="font-sans min-h-screen bg-gray-50">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[500px] flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: "url(/images/marketing-digital/167088.jpg)",
          }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black to-flowkraft-primary opacity-90"></div>

        <div className="container mx-auto px-4 relative z-10 py-20">
          <div className="flex items-center justify-center mb-8">
            <Target className="w-16 h-16 text-flowkraft-secondary" />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 text-white">
            Marketing Digital
          </h1>
          <p className="text-xl text-center text-gray-200 max-w-3xl mx-auto">
            Stratégies digitales pour augmenter votre visibilité en ligne
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            Boostez Votre Présence Digitale
          </h2>
          <p className="text-lg text-gray-700 mb-4">
            Nous élaborons des stratégies marketing sur mesure pour maximiser
            votre visibilité, attirer des leads qualifiés et développer votre
            chiffre d'affaires.
          </p>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4 max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            Nos Services Marketing
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Search className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                SEO / SEA
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Audit SEO complet
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Optimisation on-page & off-page
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Campagnes Google Ads
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <TrendingUp className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Content Marketing
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Stratégie de contenu
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Rédaction d'articles de blog
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Livres blancs & études de cas
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Share2 className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Social Media
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Gestion de communautés
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Création de contenu
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Publicités sociales
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <Target className="w-12 h-12 text-flowkraft-primary mb-4" />
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Analytics & Reporting
              </h3>
              <ul className="space-y-2">
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Configuration GA4
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Tableaux de bord personnalisés
                </li>
                <li className="flex items-center text-gray-700">
                  <CheckCircle className="w-5 h-5 text-flowkraft-primary mr-2" />
                  Rapports mensuels
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: "url(/images/main/2149755776.jpg)" }}
        ></div>
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-flowkraft-primary to-black opacity-90"></div>

        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white">
            Développez votre visibilité en ligne
          </h2>
          <Link
            to="/#contact"
            className="inline-block bg-white text-flowkraft-primary px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors"
          >
            Demander une stratégie
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarketingDigital;
